<template>
<g>
  <path :class="{ selected: isSelected }" :d="getPoints" :style="{fill: color }" ref="path" />
  <KobiViewTemplateTag v-if="data.troisTag && center" :tag="data.troisTag" :element="data" :center="getCenter" />
</g>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import KobiViewTemplateTag from './KobiViewTemplateTag.vue';
import * as d3 from 'd3';
const line = d3.line().curve(d3.curveLinearClosed);
      
export default {
  props: ['data'],

  components: { KobiViewTemplateTag },

  computed: {
    ...mapState('general', ['group', 'grouping']),
    ...mapGetters('general', ['getSelectedElements']),
    
    getPoints() {
      return line(this.data.TempPbi2DGeometry.Points);
    },

    getCenter() {
      return d3.polygonCentroid(this.data.TempPbi2DGeometry.Points);
    },

    isSelected() {
      return this.getSelectedElements.find(x => x.ID == this.data.ID);
    },

    color() {
      return this.data.troisColor || '#aaaaaa';
    },
  },

  methods: {
    getColor() {
      if(this.group)
        return this.grouping.find(x => x.group == this.data[this.group]).color;
      return 'aaaaaa'
    },

    setColor() {
      this.colorFill = '#' + this.getColor();
    },

    setCenter() {
      if(!this.$refs.path) return;
      const bbox = this.$refs.path.getBBox();
      this.center = [ bbox.x + bbox.width/2, bbox.y + bbox.height/2 ];
    },
  },
  
  watch: {
    group() {
      this.setColor();
    },
    grouping() {
      this.setColor();
    },
  },

  data() {
    return {
      container: null,
      colorFill: '#aaa',
      center: null,
    }
  },

  mounted() {
    this.setColor();
    this.setCenter();
  },
}
</script>

<style>
.selected {
  stroke: yellow;
  stroke-width: 1;
}
</style>